import React from 'react';

const ManagePermissionGroup = React.lazy(() =>
  import('./ManagePermissionGroup'),
);

export { ManagePermissionGroup };
